import { create } from 'zustand'

interface ModalActiveAccountState {
  modalActiveAccount: {
    isOpen: boolean
    onSuccess?: () => void
  }
  setModalActiveAccount: (modalActiveAccount: {
    isOpen: boolean
    onSuccess?: () => void
  }) => void
  reset: () => void
}

const initialState = {
  modalActiveAccount: {
    isOpen: false
  }
}

export const useModalActiveAccountStore = create<ModalActiveAccountState>()(
  (set) => ({
    ...initialState,
    setModalActiveAccount: (modalActiveAccount) => set({ modalActiveAccount }),
    reset: () =>
      set({
        modalActiveAccount: initialState.modalActiveAccount
      })
  })
)
